import React, { useContext } from 'react';
import classnames from 'classnames';
import { I as Icon } from './Icon-8KKXFsxm.js';
import { F as Flex } from './Flex-DYMK9YNN.js';
import { a as ComboboxContext } from './ComboboxProvider-DdsdhWRT.js';

var styles = {"option":"_5QdRGmaNHvc-"};

function ComboboxOption(props) {
    const { selected, selectionHandler } = useContext(ComboboxContext);
    const isSelected = selected.some(selection => selection.id.toString() === props.id.toString());
    return (React.createElement("li", { key: props.id, tabIndex: -1, "data-selected": isSelected, role: "option", "aria-selected": isSelected, onClick: () => selectionHandler &&
            selectionHandler({ id: props.id, label: props.label }), className: classnames(styles.option) },
        React.createElement(Flex, { template: props.prefix ? ["shrink", "grow"] : ["grow"] },
            props.prefix,
            props.label),
        React.createElement("div", null, isSelected && React.createElement(Icon, { name: "checkmark", color: "blue" }))));
}

export { ComboboxOption as C };
